import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectWidgetProperty } from 'modules/Editor/store/infographSelector';
import { updateWidget } from 'modules/Editor/store/infographSlice';
import { getElementForWidgetId } from 'utils/dom';
import { DEFAULT_NR_ICONS } from 'widgets/IconWidget/IconWidget.config';
import { getHeightOfGrid } from 'widgets/IconWidget/IconWidget.helpers';
import { IconWidgetData } from 'widgets/IconWidget/IconWidget.types';
import { TotalItemsDropdown } from 'widgets/IconWidget/ToolbarComponents/TotalItemsDropdown';
import { useEditor, useWidget } from 'widgets/sdk';

import { ComponentWidgetIdKeys, StatChartWidgetData } from '../StatChartWidget.types';

export const TotalItems = () => {
  const { componentWidgetIdMap } = useWidget<StatChartWidgetData>();
  const { boundingBox } = useEditor();
  const dispatch = useAppDispatch();

  const iconGridWidgetId = componentWidgetIdMap[ComponentWidgetIdKeys.IconGrid];
  const numberOfIcons = useAppSelector(
    selectWidgetProperty<IconWidgetData, 'numberOfIcons'>(iconGridWidgetId, 'numberOfIcons'),
  );

  const onChangeIconNumber = (newNumberOfIcons: number) => {
    if (!newNumberOfIcons || newNumberOfIcons === numberOfIcons) return;
    // if the widget is not rendered yet we can't measure the height
    if (!getElementForWidgetId(iconGridWidgetId)) return;

    const heightPx = getHeightOfGrid(iconGridWidgetId, newNumberOfIcons);

    dispatch(updateWidget({ widgetId: iconGridWidgetId, widgetData: { numberOfIcons: newNumberOfIcons, heightPx } }));
    setTimeout(() => boundingBox.updateRect(), 0);
  };

  return <TotalItemsDropdown onChange={onChangeIconNumber} numberOfIcons={numberOfIcons || DEFAULT_NR_ICONS} />;
};
